import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject5() {
  var data = _taggedTemplateLiteralLoose(["\n\tbox-shadow: 0 0 0 2px ", ";\n\tcolor: ", ";\n\n\t*:hover > & {\n\t\tcolor: ", ";\n\t}\n"]);

  _templateObject5 = function () {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteralLoose(["\n\talign-items: center;\n\tappearance: none;\n\tborder: none;\n\tdisplay: flex;\n\tjustify-content: center;\n\tmargin: 0;\n\toutline: none;\n\tpadding: 0;\n\tposition: relative;\n"]);

  _templateObject4 = function () {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\tbackground: currentColor;\n\tcolor: ", ";\n\tdisplay: grid;\n\theight: 6px;\n\tmargin: auto;\n\ttransition: all ", " linear;\n\twidth: 6px;\n\n\t*:hover > & {\n\t\tcolor: ", ";\n\t}\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: grid;\n\tgrid-template-columns: repeat(3, 1fr);\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tborder: 1px solid transparent;\n\tborder-radius: ", ";\n\tcursor: pointer;\n\tdisplay: grid;\n\tgrid-template-columns: auto;\n\tgrid-template-rows: repeat(3, calc(92px / 3));\n\toutline: none;\n\twidth: 92px;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css, styled, ui } from '@wp-g2/styles';
export var AlignmentMatrixControlView = styled.div(_templateObject(), ui.get('controlBorderRadius'));
export var RowView = styled.div(_templateObject2());
export var PointView = styled.span(_templateObject3(), ui.get('lightGray700'), ui.get('transitionDurationFaster'), ui.get('colorAdmin'));
export var CellView = styled.span(_templateObject4());
export var activePoint = css(_templateObject5(), ui.get('black'), ui.get('black'), ui.get('black'));